import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Store} from '@ngxs/store';
import {Emittable, Emitter, EmitterService} from '@ngxs-labs/emitter';
import {DataState} from '../../store/data.state';

@Injectable({
  providedIn: 'root'
})
export class RedirectResolver implements Resolve<undefined> {

  @Emitter(DataState.getFEConfigurationOnStart)
  private getFEConfiguration!: Emittable<string>;

  constructor(private readonly emitter: EmitterService, private readonly store: Store) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<undefined> {
    const flowIdFromSession = this.store.selectSnapshot<string>((state: any) => state.whitebricks.flowId);
    const tokenFromSession = this.store.selectSnapshot<string>((state: any) => state.whitebricks.token);
    if (flowIdFromSession && !tokenFromSession) {
      this.getFEConfiguration.emit(flowIdFromSession);
    }
    this.emitter.action(DataState.redirectToActualPage).emit();
    return of(undefined);
  }
}
